import React from 'react'
import { compose } from 'recompose'
import { Grid } from 'semantic-ui-react'
import Container from 'components/Container'
import CmsApis from 'apis/cmsApis'
import Paper from 'material-ui/Paper'
import StateToolBar from 'components/bars/StateToolBar'
import { updateObject } from 'helpers/objectHelpers'
import withEditPage from 'hocs/extends/withEditPage'
import FormLevelCBanner from 'components/forms/FormLevelCBanner'

const GlobalBanner = compose(
  withEditPage({
    resourceName: 'globalBanner',
    getFetchAction: () => CmsApis.getGlobalBanner,
    getUpdateAction: () => CmsApis.updateGlobalBanner,
  })
)(
  ({
    globalBanner,
    globalBanner: {
      data,
    },
    onChange,
    onSave,
    saveStatus,
    isStateChanged,
    setIsStateChanged,
    onDiscardChange,
  }) => {
    console.log('global data : ', data)
    if(!data){
      return null
    }
    const handleGlobalUpdate = (globalBanner) => {
      setIsStateChanged(true)
      return onChange(globalBanner);
    }
    const handleDataUpdate = (val) => {
      return handleGlobalUpdate(updateObject(globalBanner, { data: val }))
    }
    return (
      <div>
        <Container>
          <Paper>
            <StateToolBar
              primary={isStateChanged}
              isStateChanged={isStateChanged}
              onDiscard={() => {
                setIsStateChanged(false)
                return onDiscardChange()
              }}
              onSave={onSave}
              saveStatus={saveStatus}
            />
            <Grid columns={3} centered>
              <Grid.Column width={6}>
                <FormLevelCBanner
                  value={data}
                  onChange={handleDataUpdate}
                />
              </Grid.Column>
            </Grid>
          </Paper>
        </Container>
      </div>
    )
  }
)

GlobalBanner.propTypes = {}
GlobalBanner.defaultProps = {}

export default GlobalBanner



// WEBPACK FOOTER //
// ./src/pages/GlobalBanner/GlobalBanner.js